module.exports = __webpack_public_path__ + "static/fremont.4a16e976.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/fremont.png
// module id = 443
// module chunks = 168707334958949